<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Lt9lqC/d2d_images/cover.jpg?1720280501750" alt="This image is the cover for the book Presa da due bagnini"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Presa da due bagnini
      </h1>
      <p class="bookDescription body article font2">
        <p>Katie White è una nuotatrice professionista ventiduenne, che aspira a gareggiare alle Olimpiadi. Ogni giorno va in spiaggia per lavorare sul suo allenamento nuotando nell'oceano... e per fare alcune cose segrete e maliziose.<br/> Adora, tra l’altro, rifarsi gli occhi con i bagnini. Quei costumi da bagno succinti sui corpi muscolosi e abbronzati la mettono davvero di buon umore. Però i bagnini danno l’impressione di non notarla affatto, soprattutto dopo che ha rotto col fidanzato Chad, bagnino anche lui.<br/> Un giorno Katie viene sorpresa da un violento temporale in un luogo isolato e due bagnini vengono in suo soccorso. Uno di questi è Chad!<br/> Scampata alla morte per un pelo, bloccata dalla tempesta nel capanno di pronto soccorso, Katie è terribilmente congelata. Saranno i suoi due soccorritori a riscaldarla per bene, a poco a poco...<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jasmine Black, Magali S.
      </h2>
      
      <p class="authorDescription body article">Jasmine Black scrive storie erotiche esclusivamente per la Spunky Girl Publishing. Le sue passioni sono l’escursionismo, il campeggio, il giardinaggio, la lettura e la scrittura. Altre storie erotiche sul sito jasmine-black.com<br/></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Spunky Girl Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f24ab40e